/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */

import * as React from "react";
import { LocalizationInfo } from "@emt/emt-localization/lib/localization-info";

export const defaultLocInfo: LocalizationInfo = new LocalizationInfo({}, false, new Map<string, number>(), 0);

export const LocalizationContext = React.createContext<LocalizationInfo>(defaultLocInfo);
